import { getCheckAddressModuleData } from "../../../../../store/selectors";
import { setFlat, setHouse, setStreet } from "./common";
export var setAddressDataFromYams = function setAddressDataFromYams() {
  return function (dispatch, getState) {
    var _getCheckAddressModul = getCheckAddressModuleData(getState()),
      connected = _getCheckAddressModul.connected,
      flat = _getCheckAddressModul.flat,
      house = _getCheckAddressModul.house,
      houseId = _getCheckAddressModul.houseId,
      street = _getCheckAddressModul.street,
      streetId = _getCheckAddressModul.streetId;
    if (!connected) return;
    dispatch(setStreet({
      id: streetId,
      isConnected: true,
      label: street
    }));
    dispatch(setHouse({
      id: houseId,
      isConnected: true,
      label: house
    }));
    dispatch(setFlat(flat));
  };
};